import { render, staticRenderFns } from "./ScenariosPage.vue?vue&type=template&id=b98056b6"
import script from "./ScenariosPage.vue?vue&type=script&lang=ts"
export * from "./ScenariosPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports